import script from "./ToursWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ToursWidget.vue?vue&type=script&setup=true&lang=js"

import "./ToursWidget.vue?vue&type=style&index=0&id=345eb318&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-345eb318"]])

export default __exports__